import { styled } from '@clickcease/cc-client-components-lib'

export const ExtraOptionPopOverStyled = styled('div', {
  boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: '4px',
  background: '#FFFFFF',
  position: 'absolute',
  padding: '8px 0px 8px 0px',
  width: '211px',
  zIndex: '10',
  right: '9px',
  top: '-25px',
})

export const ExtraOptionRow = styled('div', {
  height: '32px',
  width: '100%',
  color: '$mainTextColor',
  fontWeight: '$l',
  fontFamily: 'Open Sans',
  fontSize: '$md',
  display: 'flex',
  cursor: 'pointer',
  lineHeight: '32px',

  ['&:hover']: {
    background: '#FFE3DE',
  },

  ['> svg']: {
    height: '15.5px',
    width: '15.5px',
    margin: '7px 10px 10px 8px',
  },
})
